<template>
    <b-modal hide-footer hide-header class="modal p-0 m-0 " tabindex="-1" role="dialog"  id="campaign-modal" aria-hidden="false" ref="campaign-modal">
        <!-- <div class="modal-dialog modal-dialog-centered campaign-modal-dialogue" role="document"> -->
            <div class=" m-0 p-0 campaign-modal">
                <div class="modal-header p-0 bg-gradient-campaign mb-1"
                    :style="{ backgroundImage:  'url(' + activeCampaign.thumbnail.cover_url + ')' }">
                    <div class="col-12">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal">
                            <svg-icon  :name="this.brand +'/cross'" style="transform: rotate(45deg); background-color: white; border-radius: 50%;" class="mx-1 mt-1" width="30" height="30" />
                        </button>
                    </div>
                </div>
                <div class="modal-body p-0 col-12">
                    <div class="col-12 float-left">
                        <div>
                            <div class="mt-4">
                                <div class="w-100">
                                    <div class="container"  ref="modal-container">
                                        <div class="row">
                                            <h5 v-if="activeCampaign.title != ''" class="modal-title col-12 campaign-title" > {{activeCampaign.title}} </h5>
                                            <div class="row pt-3 pb-3 mt-n1 text-center">
                                                <div class="col-12 ml-1 mr-1">
                                                    <p>{{activeCampaign.text}}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-12 text-center">
                                            <b-button v-if="activeCampaign.url === '' || activeCampaign.url === null" class=" btn btn-primary px-4 py-3 mt-3 rounded-pill align-items-center justify-content-center" data-dismiss="modal" @click="closeModal" >
                                                <span> Close <svg-icon class="arrow-right-find"  :name="this.brand +'/arrow-right'"></svg-icon></span>
                                            </b-button>
                                            <b-button v-else id="close" class="btn btn-primary px-4 py-3 mt-3 rounded-pill align-items-center justify-content-center" @click="addToImpression('clickthrough', activeCampaign.url, activeCampaign.id)" >
                                                <span >{{activeCampaign.url_button_text}} <svg-icon class="arrow-right-find"  :name="this.brand +'/arrow-right'"></svg-icon></span>
                                            </b-button>
                                        </div>
                                    </div>
                                 </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        <!-- </div> -->
    </b-modal>
 </template>
<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import mutationsMapping from '@/store/mutations-mapping'
import { BModal } from 'bootstrap-vue';

const whitelabel = require('../../whitelabel.config')[process.env.VUE_APP_BRAND]

export default {
    components: {
        BModal,
    },
    data() {
        return {
            brand: whitelabel.brand,
        }
    },
    computed: {
        ...mapState([
            'activeCampaign',
            'activeCampaignImpression',
        ]),
    },
    methods: {
        ...mapMutations(mutationsMapping),
        ...mapActions([
            'recordCampaignImpression',
            'resetActiveCampaignAndImpression',
        ]),
        addToImpression(action) {
            this.recordCampaignImpression({
                params: {
                    campaign_id: this.activeCampaign.id,
                    action,
                    impression_id: action === 'clickthrough' ? this.activeCampaignImpression.id : null,
                },
            })
            if (action === 'clickthrough') {
                window.open(this.activeCampaign.url)
            }
        },
        closeModal() {
            this.$refs['campaign-modal'].hide()
            this.resetActiveCampaignAndImpression()
        },

    },
    created() {
        this.addToImpression('view')
    },
    mounted() {
        this.$refs['campaign-modal'].show()
    },

}
</script>
<style lang="scss">
    .save-button-section{border-radius: 0px 0px 9px 9px;}

    .bg-gradient-campaign{
        height: 250px;
        background-repeat: no-repeat;
        background-position: center;
        margin-bottom: 20px;
        background-size: cover;
    }
    .campaign-modal{
        padding: 0px !important;
        margin: 0px !important;
    }
    .campaign-modal-dialogue{
        margin: 0px !important;
    }
    .modal-content{
        padding: 0px !important;
    }

    .modal-body{
        margin-bottom: 10px;
    }
    .modal-header{
        display: block !important;
        margin-top: 0px !important;
    }

</style>
